type BuildParams = {
  percentage?: string
  isEditing: boolean
}

export function buildSaveMoneyByReceivablesPageViewedPayload({ percentage, isEditing }: BuildParams) {
  return {
    percentage: percentage ? Math.min(Number(percentage), 100) : 0,
    is_editing: isEditing
  }
}
